import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_uric",
  "use": "icon-icon_uric-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-icon_uric\"><g fill=\"#94C710\" fill-rule=\"evenodd\"><rect transform=\"rotate(45 11.146 10.146)\" x=\"8.646\" y=\".146\" width=\"5\" height=\"20\" rx=\"2.5\" /><path d=\"m16.25 14 2.298 2.328a3.35 3.35 0 0 1 .952 2.35c0 1.834-1.455 3.322-3.25 3.322S13 20.512 13 18.678c0-.918.364-1.748.951-2.35L16.25 14Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol